import ConfigFile from "../../../datasets/config_file";

export const calculateMoodPoints = (chgMoodPoints, periodEnd, currentMoodPoints, moodPointHistory) => {
    const  moodPointMultiplier = +ConfigFile.gameBoard.moodPointMultiplier;
    if (periodEnd && periodEnd === true) {
        moodPointHistory.totalMoodPoints =
            +moodPointHistory.totalMoodPoints +  +moodPointHistory.currentMonthMoodPoints;
        moodPointHistory.moodPointMonths = +moodPointHistory.moodPointMonths + 1;
        moodPointHistory.currentMonthMoodPoints = 0;
    }
    const fullMoodPoints = +chgMoodPoints * moodPointMultiplier;
    currentMoodPoints = 
        (+currentMoodPoints + +fullMoodPoints).toString();
    moodPointHistory.currentMonthMoodPoints =
        +moodPointHistory.currentMonthMoodPoints + +fullMoodPoints;
    const returnObj = {moodPoints: currentMoodPoints, moodPointHistory: moodPointHistory};
    return returnObj;
}

export default calculateMoodPoints;